<template>
  <div class="min-h-32 flex items-center">
    <AnimatedText
      v-if="variant === 'text'"
      :colors="['#3F55BF']"
      :translations="loadingMessages"
      wrap
    />
    <RevSpinner v-else size="small" />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevSpinner } from '@ds/components/Spinner'

import AnimatedText from '~/components/AnimatedText/AnimatedText.vue'

import animatedTextTranslations from './AnimatedText.translations'
import { shuffleMessages } from './Loader.utils'

export type LoaderVariant = 'spinner' | 'text'

const { variant = 'spinner' } = defineProps<{
  variant?: LoaderVariant
}>()

const i18n = useI18n()

const loadingMessages = shuffleMessages(
  Object.values(animatedTextTranslations).map((t) => i18n(t)),
)
</script>
